


export function withQuery(url, params = {}) {
  const search = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== '') {
      search.append(key, String(value));
    }
  }

  const query = search.toString();
  return query ? `${url}?${query}` : url;
}


export async function getJson(url, params) {
  try {
    const response = await fetch(withQuery(url, params), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });

    const data = await response.json();


    if (!response.ok && data && typeof data === 'object' && !('error' in data)) {
      return { ...data, error: `Request failed (${response.status})`, status: response.status };
    }

    return { ...data, status: response.status };
  } catch {
    return { error: 'Network error', status: 0 };
  }
}


export async function postForm(url, fields = {}) {
  const body = new FormData();

  for (const [key, value] of Object.entries(fields)) {
    if (value !== undefined && value !== null) {
      body.append(key, typeof value === 'boolean' ? (value ? '1' : '') : String(value));
    }
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      body,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });

    const data = await response.json();

    if (!response.ok && data && typeof data === 'object' && !('error' in data)) {
      return { ...data, error: `Request failed (${response.status})`, status: response.status };
    }

    return { ...data, status: response.status };
  } catch {
    return { success: false, ok: false, error: 'Network error', status: 0 };
  }
}
